// ✅ أضف هنا - دالة للحصول على headers مع token
  const getToken = () => {
    // Try common storage locations and token key names
    const candidates = [
      localStorage.getItem("token"),
      sessionStorage.getItem("token"),
      localStorage.getItem("accessToken"),
      sessionStorage.getItem("accessToken"),
    ];

    for (let t of candidates) {
      if (t) return t.startsWith("Bearer ") ? t.slice(7) : t;
    }

    // Try user object stored in storage
    const userStr =
      localStorage.getItem("user") || sessionStorage.getItem("user");
    if (userStr) {
      try {
        const u = JSON.parse(userStr);
        if (u.token)
          return u.token.startsWith("Bearer ") ? u.token.slice(7) : u.token;
        if (u.accessToken) return u.accessToken;
      } catch (e) {
        // ignore
      }
    }

    // Try cookie named `token`
    try {
      const m =
        document.cookie && document.cookie.match(/(?:^|; )token=([^;]+)/);
      if (m) return decodeURIComponent(m[1]);
    } catch (e) {}

    return null;
  };

  const decodeJwtPayload = (token) => {
    if (!token) return null;
    const parts = token.split(".");
    if (parts.length < 2) return null;
    try {
      // base64url -> base64
      let payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
      const pad = payload.length % 4;
      if (pad) payload += "=".repeat(4 - pad);
      return JSON.parse(atob(payload));
    } catch (e) {
      return null;
    }
  };

  const getAuthHeaders = (isJson = true) => {
    const token = getToken();
    const headers = { Accept: "application/json" };
    if (isJson) headers["Content-Type"] = "application/json";
    if (token) headers["Authorization"] = `Bearer ${token}`;
    return headers;
  };

export { getToken, decodeJwtPayload, getAuthHeaders };